export const environment = {
  production: true,
  apiHost: 'https://staging.api.newscube.de/api',
  socketHost: 'https://staging.api.newscube.de',
  cdnHost: 'https://staging.cdn.newscube.de',
  exportHost: 'https://staging.export.newscube.de',
  clickHost: 'https://staging.export.newscube.de',
};
